import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#2b221d] text-gray-200 py-8 px-4 ">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        {/* Logo and Name */}
        <div className="flex items-center gap-3 mb-4 md:mb-0">
          <img src="/images/logo.png" alt="Manar Logo" className="h-10 w-auto" />
          <span className="text-2xl font-bold tracking-wide font-playfair">Manar</span>
        </div>
        {/* Navigation Links */}
        <nav className="flex flex-wrap gap-6 text-sm font-medium">
          <a href="/" className="hover:text-white transition">Home</a>
          <a href="/about" className="hover:text-white transition">About Us</a>
          <a href="/services" className="hover:text-white transition">Services</a>
          <a href="/portfolio" className="hover:text-white transition">Interior</a>
          <a href="/management" className="hover:text-white transition">Management</a>
          <a href="/contact" className="hover:text-white transition">Contact</a>
        </nav>
        {/* Social Icons */}

      </div>
      <div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm text-gray-400">
        &copy; {new Date().getFullYear()} Manar. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
